/**
 * Payment activity tracking type values
 */
export enum PaymentActivityTrackingTypeEnum {
	/**
	 * Represents a payment request initialized with the provider
	 */
	PAYMENT_REQUESTED = 'payment_requested',

	/**
	 * Payment authorized by provider, capture required for money to move
	 */
	PAYMENT_AUTHORIZED = 'payment_authorized',

	/**
	 * Payment captured, money has moved
	 */
	PAYMENT_CAPTURED = 'payment_captured',

	/**
	 * Payment attempt failed
	 */
	PAYMENT_FAILED = 'payment_failed',

	/**
	 * Payment cancelled
	 */
	PAYMENT_CANCELLED = 'payment_cancelled',

	/**
	 * Retry after failure
	 */
	PAYMENT_RETRY = 'payment_retry',

	/**
	 * Refund initiated with provider, awaiting response
	 */
	PAYMENT_REFUND_REQUESTED = 'payment_refund_requested',

	/**
	 * Refund authorized but not yet captured
	 */
	PAYMENT_REFUND_AUTHORIZED = 'payment_refund_authorized',

	/**
	 * Refund captured, money returned
	 */
	PAYMENT_REFUNDED = 'payment_refunded',
}
